import { render, staticRenderFns } from "./cms.vue?vue&type=template&id=0c2b99f0&scoped=true"
import script from "./cms.vue?vue&type=script&lang=js"
export * from "./cms.vue?vue&type=script&lang=js"
import style0 from "./cms.vue?vue&type=style&index=0&id=0c2b99f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b99f0",
  null
  
)

export default component.exports